import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import {
  Accordeon, AccordeonItem, Icon, JSONViewer
} from '@febos-io/design';
import { hooks } from '@febos-io/common';

import { useTranslation } from '../../hooks';

function findInObjects(messageType = 'request') {
  return (e) => {
    try {
      if (typeof e.mensaje === 'object') {
        const message = e.mensaje.mensaje || e.mensaje.message || '';
        return message.toLowerCase() === messageType;
      }
    } catch {
      console.error('Error finding message type in event object');
    }
    return false;
  };
}

const getDataAsync = async (
  events,
  downloadContentCallback,
  setRequestObject,
  setResponseObject
) => {
  const request = events.find(findInObjects('request'));
  const response = events.find(findInObjects('response'));
  let requestObjectFinding = null;
  let responseObjectFinding = null;
  if (request) {
    const attachments = request.mensaje.adjuntos
      || request.mensaje.objeto
      || request.mensaje.attachments[0];
    requestObjectFinding = await downloadContentCallback({ url: attachments, });
    setRequestObject(requestObjectFinding);
  }
  if (response) {
    const attachments = response.mensaje.adjuntos
      || response.mensaje.objeto
      || response.mensaje.attachments[0];
    responseObjectFinding = await downloadContentCallback({ url: attachments, });
    setResponseObject(responseObjectFinding);
  }
};

export function RecordsHeader({ events, user, company, }) {
  const { t, } = useTranslation();
  const {
    callback: downloadContentCallback,
  } = hooks.useDownloadContentFileFromS3PreSignedUrlCallback();

  const [requestObject, setRequestObject] = useState(null);
  const [responseObject, setResponseObject] = useState(null);

  useEffect(() => {
    getDataAsync(events, downloadContentCallback, setRequestObject, setResponseObject);
  }, [downloadContentCallback, events]);

  return (
    <>
      <div className="row p-1">
        <div className="row col-6">
          <div className="col-2">
            <Icon icon="user" fontSize="45px" />
          </div>
          <div className="row col-10">
            <span className="col-12">{`${t('Name')}: ${user?.name}`}</span>
            <span className="col-12">{`${t('Email')}: ${user?.email}`}</span>
          </div>
        </div>
        <div className="row col-6">
          <div className="col-2">
            <Icon icon="building" fontSize="45px" />
          </div>
          <div className="row col-10">
            <span className="col-12 small">{`${t('Company')}: ${company?.businessName}`}</span>
            <span className="col-12">{`${t('IUT')}: ${company?.identificationNumber}`}</span>
          </div>
        </div>
      </div>
      <Accordeon className="card">
        <AccordeonItem title={t('Log details')}>
          <div className="row">
            <div className="col-6">
              {t('REQUEST')}
              :
              {requestObject && <JSONViewer json={requestObject} mode="view" />}
            </div>
            <div className="col-6">
              {t('RESPONSE')}
              :
              {responseObject && <JSONViewer json={responseObject} mode="view" />}
            </div>
          </div>
        </AccordeonItem>
      </Accordeon>
    </>
  );
}

RecordsHeader.propTypes = {
  events: PropTypes.array.isRequired,
  user: PropTypes.object.isRequired,
  company: PropTypes.object.isRequired,
};
export default RecordsHeader;
